import 'slick-carousel/slick/slick';
import { Modal } from 'bootstrap';
//import { __ } from '@wordpress/i18n';

( function ( $ ) {
	const { __, _x, _n, sprintf } = wp.i18n;
	/**
	 * Product Gallery
	 */
	const productGallery = $( '.woocommerce-product-gallery__wrapper' );
	const btnBuyNow = $( '.buy-now' );
	const btnBuyClose = $( '.buy-close' );

	if ( productGallery.length ) {
		productGallery.slick( {
			arrows: false,
			dots: true,
		} );
	}

	btnBuyNow.click( function ( e ) {
		e.preventDefault();
		$( this ).next( '.entry-add-to-cart' ).addClass( 'active' );
	} );

	btnBuyClose.click( function ( e ) {
		e.preventDefault();
		$( this ).closest( '.entry-add-to-cart' ).removeClass( 'active' );
	} );

	/**
	 * Categories / Catalog
	 */
	const shopPage = $( '.page-template-page-shop' );
	if ( shopPage.length ) {
		const categoriesOffCanvas = $( '#shop__filter', shopPage );
		const categoriesFilterList = $( 'ul', categoriesOffCanvas );
		const categoriesFilterTrigger = $( '#shop__filter__trigger', shopPage );
		const productCategoryBlocks = $(
			'.wp-block-indy-woo-product-category'
		);


		productCategoryBlocks.each( function ( index, element ) {
			const catName = $( this ).data( 'catname' );
			const catId = $( this ).data( 'catid' );
			const productContainer = $( '.products', element );
			const products = $( '.product', element );
			const expander = $( '.category__expand', element );
			// Append category filter list
			categoriesFilterList.append(
				`<li class="nav-item"><a href="#" data-filter="${ catId }" class="nav-link">${ catName }</a></li>`
			);
			/*// Check if more than 6 products are available
			if ( products.length <= 6 ) {
				expander.hide();
			} else {
				const catHeight =
					$( products[ 0 ] ).height() + $( products[ 2 ] ).height();
				productContainer.height( catHeight );
				expander.click( function ( e ) {
					e.preventDefault();
					productContainer.height( 'auto' );
				} );
			}*/
		});

		$( 'a.nav-link', categoriesFilterList ).click( function ( e ) {
			e.preventDefault();
			const filterId = parseInt( $( this ).data( 'filter' ) );
			const filterLabel = $( this ).text();
			$( 'html, body' ).scrollTop( 0 );
			// Filter category blocks
			if ( ! filterId ) {
				productCategoryBlocks.show();
			} else {
				productCategoryBlocks.each( function ( index, element ) {
					if ( $( element ).data( 'catid' ) === filterId ) {
						$( element ).show();
					} else {
						$( element ).hide();
					}
				} );
			}
			// Change nav link state
			$( 'a.nav-link', categoriesFilterList ).removeClass( 'active' );
			$( this ).addClass( 'active' );
			// Set trigger label
			categoriesFilterTrigger.find( '.value' ).text( filterLabel );
		} );
	}

	/**
	 * Cart modal
	 */
	const cartModalOptions = {
		backdrop: false,
	};

	const cartModal = new Modal(
		document.getElementById( 'woo__cart-modal' ),
		cartModalOptions
	);

	$( '.woo__cart-head a, a[href$="/warenkorb/"], a[href$="/cart/"], a[href$="/panier/"]' ).click( ( e ) => {
		e.preventDefault();
		cartModal.show();
	} );


	/**
	 * Maximized select
	 */
	const selectField = $( '.woo-maxselect' );
	const setMaxSelect = function ( select ) {
		const selectOptions = $( 'option', select );
		const targetId = $( select ).attr( 'id' );
		const options = [];
		let markup = `<div class="woo-maxselect-btn" data-targetid="${ targetId }">`;

		selectOptions.each( ( index, element ) => {
			if ( $( element ).attr( 'value' ) !== '' ) {
				const option = [];
				option.label = $( element ).text();
				option.value = $( element ).attr( 'value' );
				option.selected = !!($(element).attr('selected'));
				options.push( option );
			}
		} );

		options.forEach( function ( element ) {
			const selected = element.selected ? ' class="selected"' : '';
			markup += `<button data-value="${ element.value }"${ selected }>${ element.label }</button>`;
		} );

		markup += '</div>';

		$( markup ).insertBefore( select );
	};
	selectField.each( function ( index, element ) {
		setMaxSelect( element );
		$( element ).hide();
	} );
	$( 'body' ).on( 'click', '.woo-maxselect-btn button', function ( e ) {
		e.preventDefault();
		const parent = $( this ).parent('.woo-maxselect-btn');
		if( $(this).hasClass('selected') ){
			$( '.reset_variations' ).click();
			$(this).removeClass( 'selected' );
		}else{
			$( this ).siblings( 'button' ).removeClass( 'selected' );
			$( this ).addClass( 'selected' );
			parent.siblings('.woo-maxselect').val($(this).data('value')).change();
		}
	} );
	$('.reset_variations').click(function(e){
		e.preventDefault();
		$('.woo-maxselect-btn button').removeClass( 'selected' );
	});

	$(document).ready(function() {
		$('.woocommerce-message').fadeTo(5000,1).fadeOut(2000);
		$('.single_add_to_cart_button').removeClass('wp-element-button').addClass('is-style-outline');
	});

} )( jQuery );
